export default function CookieFooter(elem: HTMLLinkElement) {
  if (elem) {
    elem.onclick = function(e: MouseEvent) {
      e.preventDefault();
      const buttonCookie = document.querySelector('.eu-cookie-withdraw-tab') as HTMLInputElement;
      buttonCookie.click();
    }
  }
}
